export interface MarketAttributes {
  name: string;
  method: 'email' | 'API' | 'portal';
  isIncumbent?: boolean;
  status: 'quoted' | 'declined' | 'deferred' | 'renewal' | 'awaiting';
  portalUrl?: string;
}

export const getQuotingMarketNames = (markets: MarketAttributes[]) =>
  markets.filter((market) => market.status === 'quoted').map((market) => market.name);

export const getDeclinedMarketNames = (markets: MarketAttributes[], method: 'API' | 'portal') =>
  markets.filter((market) => market.method === method && market.status === 'declined').map((market) => market.name);

export const getDeferredMarketNames = (markets: MarketAttributes[]) =>
  markets.filter((market) => market.status === 'deferred').map((market) => market.name);
